/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/merge_corvette_2': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 11.75v-7.5h-7.5L16 0l-4.25 4.25h-7.5v7.5L0 16l4.25 4.25v7.5h7.5L12 28v4h8v-4l.25-.25h7.5v-7.5L32 16l-4.25-4.25zM15.334 10h1.332v1.333h-1.332V10zM14 12h4v.667h-4V12zm3.867 1.333L16 17.066l-1.867-3.733h3.734zM4.75 4.75h6.5l-6.5 6.5v-6.5zm0 22.5v-6.5l6.5 6.5h-6.5zm10.55.636V30h-.6v-4h.6v1.886zm2-.6V30h-.6v-4h.6v1.286zM15.992 24l-5.326-10.667h2.135L16 19.732l3.199-6.399h2.135L15.992 24zm11.258 3.25h-6.5l6.5-6.5v6.5zm0-16l-6.5-6.5h6.5v6.5z"/>'
  }
})
